module.exports = __webpack_public_path__ + "img/share.03c2753a.png";